import React from "react";
import { Tabs } from "antd";
import DropItemTab from "./DropItemTab";
import DropItemSetTab from "./DropItemSetTab";
const DropItemManagementTab: React.FC = () => (
  <Tabs
    defaultActiveKey="items"
    tabBarStyle={{ paddingLeft: 24 }}
    items={[
      { key: "items", label: "드롭 아이템", children: <DropItemTab /> },
      { key: "sets", label: "아이템 세트", children: <DropItemSetTab /> },
    ]}
  />
);
export default DropItemManagementTab;
